__turbopack_context__.v({
  "video_image": "VideoPlayer-module-scss-module__G_PNxG__video_image",
  "video_player_container": "VideoPlayer-module-scss-module__G_PNxG__video_player_container",
  "video_player_iframe": "VideoPlayer-module-scss-module__G_PNxG__video_player_iframe",
});
